import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  unknownQuestionType: {
    defaultMessage: "We couldn't load the <strong>{questionType}</strong> field type at this time.",
    description: 'Shown when a form field is unable to be shown',
    id: 'form-system.unknown-question-type'
  }
});